export const ClusterStyles = {
  "text-font": ["Basier Circle Bold", "Arial Unicode MS Bold"],
  "text-size": [
    "step",
    ["get", "point_count"],
    12,
    10,
    14,
    25,
    16,
    100,
    20,
    200,
    24,
  ],
  "text-offset": [0, 0.1],
};

export const MapStyles = {
  clusterLayer: {
    "circle-stroke-width": ["step", ["get", "point_count"], 2, 10, 3, 30, 4],
    "circle-stroke-color": "#fff",
    "circle-color": [
      "step",
      ["get", "point_count"],
      "RGBA(85,85,85,0.77)",
      10,
      "RGBA(56,56,56,0.77)",
      50,
      "RGBA(26,26,26,0.77)",
      51,
      "RGBA(0,0,0,0.81)",
      100,
      "RGBA(0,0,0,0.81)",
      750,
      "RGBA(0,0,0,0.81)",
    ],
    "circle-radius": [
      "step",
      ["get", "point_count"],
      15,
      30,
      25,
      50,
      30,
      100,
      40,
      200,
      50,
      750,
      60,
    ],
  },
};
